import {
  type Recommendation,
  type RecommendationGetList,
} from 'types/services/Recommedation'
import api from './api'

export const postRecommendation = async (
  recommendationInfos: Recommendation
) => {
  try {
    const response = await api.post('/recommendation', recommendationInfos)
    return response
  } catch (error) {
    return await Promise.reject(error)
  }
}

interface SendRecommendationProps {
  question: string
  answer: string
  alert: boolean
  justification: string
  url: string
  area: string
}

export const sendRecommendation = async (
  id: number,
  infosRecommedation: SendRecommendationProps
) => {
  try {
    const response = await api.post(
      `/recommendation/${id}/send`,
      infosRecommedation
    )
    return response
  } catch (error) {
    return await Promise.reject(error)
  }
}

export const editRecommendation = async (
  id: number,
  recommendationInfos: Recommendation
) => {
  try {
    const response = await api.put(`/recommendation/${id}`, recommendationInfos)
    return response
  } catch (error) {
    return await Promise.reject(error)
  }
}

export const getListRecommendation = async (
  recommendationInfos: RecommendationGetList
) => {
  try {
    const response = await api.get('/recommendation', {
      params: recommendationInfos,
    })
    return response
  } catch (error) {
    return await Promise.reject(error)
  }
}
